import { expireCookie, setCookie } from "../helpers/cookie-service.js";
const getQueryParam = (search) => new URLSearchParams(search);
const AffiliateCookies = {
  btag: "btag",
  clickid: "click_id",
  subid: "subid",
  ctag: "ctag",
  utm_campaign: "utm_campaign",
  utm_content: "utm_content",
  utm_medium: "utm_medium",
  utm_source: "utm_source",
  utm_term: "utm_term",
  affise_click_id: "affise_click_id",
  affise_offer: "affise_offer",
  affise_pid: "affise_pid",
  partner_id: "partner_id",
  sub_id10: "sub_id10",
  gclid: "gclid",
  fbclid: "fbclid",
  msclkid: "msclkid",
  af_prt: "partner_id",
  pid: "utm_source"
};
const ConflictingCookies = [
  ["btag", "clickid"],
  ["clickid", "btag"]
];
const CookieOverrides = [
  ["pid", "utm_source"],
  ["af_prt", "partner_id"]
];
const setCookieData = (search) => {
  let allActiveCookieNames = Object.keys(AffiliateCookies).filter((key) => getQueryParam(search).get(key));
  CookieOverrides.forEach(([primary, toRemove]) => {
    if (allActiveCookieNames.includes(primary)) {
      allActiveCookieNames = allActiveCookieNames.filter((key) => key !== toRemove);
    }
  });
  const expires = expireCookie(6e4 * 60 * 24 * 30);
  allActiveCookieNames.forEach((cookieName) => {
    const cookieKey = AffiliateCookies[cookieName];
    const value = getQueryParam(search).get(cookieName);
    setCookie(cookieKey, value, { expires });
    ConflictingCookies.forEach(([target, toDelete]) => {
      if (cookieName === target) {
        setCookie(AffiliateCookies[toDelete], "", { "max-age": -1 });
      }
    });
  });
};
export {
  getQueryParam,
  setCookieData
};
